import { render, staticRenderFns } from "./radio_collection_field.vue?vue&type=template&id=52ecd4ca&lang=pug&"
import script from "./radio_collection_field.vue?vue&type=script&lang=js&"
export * from "./radio_collection_field.vue?vue&type=script&lang=js&"
import style0 from "./radio_collection_field.vue?vue&type=style&index=0&id=52ecd4ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports